import { SVGProps } from 'react'
const DownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={6}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m1 1 4 4 4-4"
    />
  </svg>
)
export default DownArrow
